export const HOME_ANCHORS = Object.freeze({
  comeFunziona: 'come-funziona',
  scopriServizi: 'scopri-servizi',
  altriServizi: 'altri-servizi',
  introductionSlider: 'introduzione-slider',
});
